import { Checkbox, Form } from 'antd'
import { FC } from 'react'

const HalfRotation: FC = () => {
    return (
        <Form.Item name={'halfRotation'} valuePropName={'checked'} label={' '}>
            <Checkbox>Полуротация</Checkbox>
        </Form.Item>
    )
}

export default HalfRotation
